// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d2749ea3","166":"fb6aa035","185":"f47671aa","340":"9e47ff7f","387":"e7543595","465":"3c2a668c","489":"5eb0da7c","503":"869112f6","586":"358ded64","626":"57e833fc","629":"d463c6e2","708":"b5beb824","736":"159f9235"}[chunkId] + ".chunk.js";
};